import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M4 15.669v-3.336C4 6.074 9.074 1 15.333 1h1.334C22.926 1 28 6.074 28 12.333v8.665a2.67 2.67 0 0 1-2.028 2.592 6 6 0 0 1-5.97 5.41h-1.45a2 2 0 0 1-1.884 1.333h-1.336a2 2 0 0 1 0-4h1.336c.872 0 1.612.555 1.886 1.334h1.448a4.665 4.665 0 0 0 4.63-4.094 2.67 2.67 0 0 1-1.965-2.575v-5.33a2.67 2.67 0 0 1 4-2.311v-1.024c0-5.523-4.478-10-10-10h-1.334c-5.523 0-10 4.477-10 10v1.025a2.667 2.667 0 0 1 4 2.311v5.329a2.667 2.667 0 1 1-5.333 0zm13.333 12.66a.663.663 0 0 0-.665-.662h-1.336a.668.668 0 0 0 0 1.333h1.336a.667.667 0 0 0 .665-.665zm-12-9.278V15.67a1.334 1.334 0 1 1 2.667 0v5.329a1.333 1.333 0 1 1-2.667 0zM24 15.669v5.329a1.333 1.333 0 1 0 2.667 0v-5.33a1.333 1.333 0 1 0-2.667 0",
      clipRule: "evenodd"
    }
  )
);
var SvgHeadsetOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var HeadsetOutlined_default = SvgHeadsetOutlined;

export { HeadsetOutlined_default as default };
